import React from 'react';
import { TrackingInfoEvent } from '../../../../../../../__generated__/loma';
import TrackingEventDescription from './TrackingEventDescription';
import { useTheme } from '../../../../../hooks/useTheme';
import styles from './TrackingEventsList.module.css';
import { clsx } from 'clsx';

export interface TrackingEventsProps {
  history: TrackingInfoEvent[];
  collapsed?: boolean;
}

const TrackingEvents = ({ history, collapsed }: TrackingEventsProps) => {
  const { bodytextDefaultNone, smalltextDefaultNone, smalltextEmphasisNone } =
    useTheme();

  const historyGroupedByDate = history.reduce(
    (
      acc: Map<string, TrackingInfoEvent[]>,
      event: TrackingInfoEvent,
    ): Map<string, TrackingInfoEvent[]> => {
      const {
        dateFormatted: [date],
      } = event;

      const eventList = acc.get(date);

      if (eventList) {
        eventList.push(event);
      } else {
        acc.set(date, [event]);
      }

      return acc;
    },
    new Map<string, TrackingInfoEvent[]>(),
  );

  return (
    <ol
      className={styles.orderedList}
      data-test="shippingHistoryEventsContainer"
    >
      {[...historyGroupedByDate.entries()].map(([date, eventList], idx) => (
        <li key={date} style={{ marginTop: idx && '1.5rem' }}>
          <span
            className={clsx({
              [styles.dateExpanded]: !collapsed,
              [styles.dateCollapsed]: collapsed,
            })}
            style={smalltextEmphasisNone}
          >
            <time>{date}</time>
          </span>
          <ol className={styles.orderedList}>
            {eventList.map(
              ({
                description,
                formattedDescription,
                city,
                state,
                dateFormatted: [, time],
              }) => {
                const timeAndLocation = (
                  <>
                    <time>{time}</time>
                    {time && (city || state) && (
                      <span aria-hidden="true">&nbsp;|&nbsp;</span>
                    )}
                    <span>
                      {city}
                      {city && state && ', '}
                      {state}
                    </span>
                  </>
                );

                return (
                  <li
                    key={`${date}${time}${city ?? ''}${state ?? ''}${
                      description ?? ''
                    }`}
                    className={styles.orderedListItem}
                  >
                    <span
                      className={clsx({
                        [styles.dateLocationExpanded]: !collapsed,
                        [styles.dateLocationCollapsed]: collapsed,
                      })}
                      style={smalltextDefaultNone}
                    >
                      {timeAndLocation}
                    </span>
                    <TrackingEventDescription
                      formattedDescription={formattedDescription}
                      description={description}
                      s={bodytextDefaultNone}
                    />
                  </li>
                );
              },
            )}
          </ol>
        </li>
      ))}
    </ol>
  );
};

export default TrackingEvents;
